import { func, number, string } from 'prop-types';
import React from 'react';

/**
 * Both the structure with the css classes as well as the close icon svg are a
 * copy from `react-select`.
 *
 * The styles are in _m-select.scss
 */

function MultiValueGroup({ label, selected, options, onClear }) {
  return (
    <div className="m-select__multi-value">
      <div className="m-select__multi-value__label">
        {label} {selected}/{options}
      </div>
      <div
        className="m-select__multi-value__remove"
        onClick={onClear}
        aria-hidden
        focusable={false}
      >
        <svg
          height="14"
          width="14"
          viewBox="0 0 20 20"
          aria-hidden="true"
          focusable="false"
          style={{ stroke: 'currentColor', fill: 'currentColor' }}
        >
          <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" />
        </svg>
      </div>
    </div>
  );
}

MultiValueGroup.propTypes = {
  label: string.isRequired,
  selected: number.isRequired,
  options: number.isRequired,
  onClear: func.isRequired,
};

export default MultiValueGroup;
